const IconArrowDown = ({className = ''}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.6 20.66"
  className={className}>
    <g>
      <path
        id="Layer_1-2"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="m2 2 16.93 16.66L35.6 2"
      ></path>
    </g>
  </svg>
);

export default IconArrowDown;
